import api from "@/shared/api/base-api";
import { TagParams, TagsResponse } from "../model/types";

export const tagApi = {
  getAll: async (params: TagParams): Promise<TagsResponse> => {
    const { data } = await api.get("/v2/shipper-tag", {
      params,
    });
    return data;
  },
};
